
import { assetPrefix } from 'config/env_config'

export const PAYMENT_TYPES = [
  {
    type: 'online',
    title: 'Pagamento online',
    subTitle: 'com cartão de crédito',
    icon: `${assetPrefix}/static/icons/online-avatar.svg`
  },
  {
    type: 'local',
    title: 'Pagamento no local',
    subTitle: 'com cartão, dinheiro ou pix',
    icon: `${assetPrefix}/static/icons/local-avatar.svg`
  }
]
